/* eslint-disable */
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { CTitle } from '../../components/Widget';
import AttackerTargetGrid from '../../components/AttackerTargetGrid';
import { useUpdateComponentState } from '../../../hooks';
import CardBg1 from '../../../../../../assets/sme/ics/attacker/card_bg_1.png';
import CardBg2 from '../../../../../../assets/sme/ics/attacker/card_bg_2.png';
import CardBg3 from '../../../../../../assets/sme/ics/attacker/card_bg_3.png';
import CardBg4 from '../../../../../../assets/sme/ics/attacker/card_bg_4.png';
import CardBg5 from '../../../../../../assets/sme/ics/attacker/card_bg_5.png';
import MisconceptionCards, {
  PSA_RISKS_ICONS,
} from '../../components/MisconceptionCards';
import WhySmeTargetReasons from '../../components/WhySmeTargetReasons';

const SHARED_ACCOUNT_CARD_BACKGROUNDS = [
  CardBg1,
  CardBg2,
  CardBg3,
  CardBg4,
  CardBg5,
];

interface Settings {
  paragraphs: any[];
}

interface ISection2Props {
  settings: Settings;
}

const Section2: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  const attackerTargetItems = useMemo(
    () =>
      paragraphsSettings?.l2Lists?.map(
        (item: { text?: string }, index: number) => ({
          ...item,
          backgroundImage:
            SHARED_ACCOUNT_CARD_BACKGROUNDS[
              index % SHARED_ACCOUNT_CARD_BACKGROUNDS.length
            ],
        })
      ),
    [paragraphsSettings?.l2Lists]
  );
  const handleMisconceptionCardsComplete = React.useCallback(() => {
    updateComponentState(p_course, p_topic, ID, 'sme-psa-section2-1');
  }, [updateComponentState, p_course, p_topic, ID]);

  return (
    <div className="topic-section-2">
      <CTitle title={paragraphsSettings?.title ?? ''} />
      <AttackerTargetGrid
        title={paragraphsSettings?.l2}
        description={paragraphsSettings?.l2Text1}
        items={attackerTargetItems}
        layout="cards-only"
        variant="shared-account"
      />
      <MisconceptionCards
        title={paragraphsSettings?.risksTitle}
        items={paragraphsSettings?.risks}
        tips={paragraphsSettings?.risksTips}
        icons={PSA_RISKS_ICONS}
        id="sme-psa-section2-1"
        onComplete={handleMisconceptionCardsComplete}
      />
      <WhySmeTargetReasons
        title={paragraphsSettings?.l1Title}
        description={paragraphsSettings?.l1SubTitle}
        items={paragraphsSettings?.l1Lists}
      />
    </div>
  );
};

export default Section2;
